(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('comparisons', {
          abstract: true,
          parent : 'storePage',
          url : '/comparisons?comparisonMetric',
          template : '<ui-view autoscroll="true"></ui-view>'
        })
        .state('comparisons.dateRange', {
          url : '/date-range?comparisonStartDate&comparisonEndDate&comparisonTab',
          data: {
            auth : { privilege : 'report.Comparisons' },
            title: 'Compare Date Ranges',
            path:'comparisons/date-range'
          },
          params: {
            comparisonTab: {type: 'int'}
          },
          templateUrl : 'StandardReports/Comparisons/DateRange/ComparisonsDateRange.tmpl.html',
          controller : 'ComparisonsDateRangeCtrl as vm'
        })
        .state('comparisons.hierarchy', {
          url : '/hierarchy?comparisonDepartment&comparisonCategory&comparisonClassification&comparisonAddressable&comparisonTab',
          data: {
            auth : { privilege : 'report.Comparisons' },
            title: 'Compare Hierarchies',
            path:'comparisons/hierarchy'
          },
          params: {
            comparisonAddressable: {type: 'bool'},
            comparisonTab: {type: 'int'}
          },
          templateUrl : 'StandardReports/Comparisons/Hierarchy/ComparisonsHierarchy.tmpl.html',
          controller : 'ComparisonsHierarchyCtrl as vm'
        });
  }

})();